import { get, post } from '@webapp-next/lib/request/webapp/apiv2';

/**
 * Get regular schedules configuration
 * @param { Number } employeeId
 * @return {Promise<{success: boolean, message: *}|{configuration: *, success: boolean}>}
 */
export async function agreedHoursGetGeneralConfiguration(employeeId) {
  try {
    const { data } = await get(
      `/api/management/v2/agreed_hours/configuration/general/${employeeId}`
    );
    return {
      success: true,
      data: data,
      message: '',
    };
  } catch (e) {
    console.error('agreedHoursGetGeneralConfiguration get error', e);
    return {
      success: false,
      data: [],
      message: e?.response?.data?.error?.message,
    };
  }
}

/**
 * Check if a regular schedule requires approval
 * @param { Number } employeeId
 * @param { Number } threshold
 * @param { Boolean } applyThreshold
 * @param { Object } workPeriod
 * @param { Number } workingDaysPerCycle
 * @param { Object } details
 * @param { String } status
 * @param { String } comment
 * @param { String } effectiveDate
 * @return {Promise<{success: boolean, needsApproval: any}|{success: boolean, message: *}>}
 */
export async function agreedHoursEmployeeApproval({
  employeeId,
  threshold,
  applyThreshold,
  workPeriod,
  workingDaysPerCycle,
  details,
  status = 'UNKNOWN',
  comment = '',
  effectiveDate = '',
}) {
  const defaultDetails = { weeks: [] };
  if (!details) {
    details = defaultDetails;
  }
  const body = {
    agreedHour: {
      threshold,
      applyThreshold,
      workPeriod: {
        ...workPeriod,
      },
      details: details,
      workingDaysPerCycle: workingDaysPerCycle,
      status: status,
      statusChangedById: employeeId,
      comment: comment,
      effectiveDate: effectiveDate,
    },
  };

  try {
    const { data } = await post(
      `/api/management/v2/agreed_hours/configuration/employee_approval/${employeeId}`,
      body
    );
    return {
      success: true,
      data: data,
      message: '',
    };
  } catch (e) {
    console.error('agreedHoursEmployeeApproval get error', e);

    return {
      success: false,
      data: [],
      message: e?.response?.data?.error?.message,
    };
  }
}
